module.exports = __webpack_public_path__ + "138d79b3345ef2bc831c084d3f04f0c6.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/power_has_a_price-768.webp
// module id = 514
// module chunks = 0